/**
 * @generated SignedSource<<caa7e541e6403c6869eddceab2420b93>>
 * @relayHash 800c6a7c64d94352aaf92fb95e241e2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c36ad232ca3ab20c494c15da8e83ca3f5b3ebc635d5b4e930790dfa9521cfa3c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type people_peopleSearchQuery$variables = {
  id: string;
};
export type people_peopleSearchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"people_issueFieldPeopleEditviewFull_PeopleEditViewWithFieldOptionsFragmentOld_suggestionsFragmentRef">;
};
export type people_peopleSearchQuery = {
  response: people_peopleSearchQuery$data;
  variables: people_peopleSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v2 = {
  "kind": "Literal",
  "name": "searchBy",
  "value": ""
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v2/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "people_peopleSearchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "people_issueFieldPeopleEditviewFull_PeopleEditViewWithFieldOptionsFragmentOld_suggestionsFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "people_peopleSearchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "email"
                              }
                            ],
                            "type": "AtlassianAccountUser"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "users(first:50,searchBy:\"\")"
              },
              {
                "args": (v4/*: any*/),
                "filters": [
                  "searchBy"
                ],
                "handle": "connection",
                "key": "people_issueFieldPeopleEditviewFull_users",
                "kind": "LinkedHandle",
                "name": "users"
              }
            ],
            "type": "JiraPeopleField"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "c36ad232ca3ab20c494c15da8e83ca3f5b3ebc635d5b4e930790dfa9521cfa3c",
    "metadata": {},
    "name": "people_peopleSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "fd3c0baba669c01ad7e476a3537d1ebe";

export default node;
